/* eslint no-irregular-whitespace: 0 */
/* eslint no-extend-native: 0 */
/* eslint func-names: 0 */
class FuncUtils {
  public stringIncludes(): void {
    if (!String.prototype.includes) {
      String.prototype.includes = function (search: string, start: number = 0) {
        if (start + search.length > this.length) {
          return false;
        }
        return this.indexOf(search, start) !== -1;
      };
    }
  }
  public arrayIncludes(): void {
    if (!Array​.prototype​.includes) {
      Array​.prototype​.includes = function (search: string, start: number) {
        start = start || 0;
        if (start < 0) start = this.length + start;
        if (start < 0) start = 0;

        for (let i = start; i < this.length; i++) {
          if (this[i] === search) {
            return true;
          }
        }
        return false;
      };
    }
  }
  public init(): void {
    this.stringIncludes();
    this.arrayIncludes();
  }
}
const funcUtils: FuncUtils = new FuncUtils();
export default funcUtils;
